// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__1-5dN","modal":"Modal_modal__30MRu"};